import React, { useContext } from "react";
import DraftDispatchContext from "../../contexts/draftDispatchContext";
import TeamLogo from "../team/TeamLogo";
import { DRAFT_ACTIONS } from "./draftReducer";

export default function TeamLogoWithRosterLink({ team, size, styleProps }) {
  const draftDispatch = useContext(DraftDispatchContext);

  return (
    <div
      style={{ cursor: "pointer" }}
      onClick={() => {
        draftDispatch({
          type: DRAFT_ACTIONS.SELECT_TEAM_ID,
          payload: team.obj.id,
        });
        draftDispatch({ type: DRAFT_ACTIONS.SELECT_TAB, payload: 2 });
      }}
    >
      <TeamLogo team={team} size={size} styleProps={styleProps} />
    </div>
  );
}
